import { ConstraintSpec } from '../constraints/constraint-spec'
import { ProcessingTimeSpec } from '../capacities/processing-time-spec'

export class SkillSetSpec {
  public id: string

  public name: string

  public conditions: ConstraintSpec[] = []
  public constraints: ConstraintSpec[] = []
  public capacities: ProcessingTimeSpec[][] = []

  public required: boolean

  public singular: boolean
}
